<script>
export default {
  name: "DidoApidocUsageOutputFormats",
};
</script>

<script setup>
import { ref, inject } from "vue";
import api from "../../../api";

const apiUrl = inject("apiUrl");

const parquetEnabled = ref(false);
api.withParquet(apiUrl).then((result) => (parquetEnabled.value = result));
</script>

<template>
  <div class="q-mt-md line-height-15">
    La majorité des routes de l'api renvoient des objets json avec le
    Content-Type
    <span class="bg-black text-white q-pa-xs"
      >application/json; charset=utf-8</span
    >. <br /><br />
    Certaines routes permettent de télécharger des données dans différents
    formats:
    <ul>
      <li>
        données d'un millésime, d'un référentiel ou d'une nomenclature au format
        csv :
        <br />
        l'api renvoient un fichier csv avec le Content-Type
        <span class="bg-black text-white q-pa-xs">text/csv; charset=utf-8</span
        >.
      </li>
      <li>
        données d'un millésime, d'un référentiel ou d'une nomenclature au format
        xlsx :
        <br />
        l'api renvoient un fichier xlsx avec le Content-Type
        <span class="bg-black text-white q-pa-xs"
          >application/vnd.openxmlformats-officedocument.spreadsheetml.sheet</span
        >.
      </li>
      <li>
        données d'un millésime, d'un référentiel ou d'une nomenclature au format
        json :
        <br />
        l'api renvoient un fichier json avec le Content-Type
        <span class="bg-black text-white q-pa-xs">application/json</span>.
      </li>
      <li v-if="parquetEnabled">
        données d'un millésime au format parquet :
        <br />
        l'api renvoient un fichier parquet avec le Content-Type
        <span class="bg-black text-white q-pa-xs"
          >application/vnd.apache.parquet</span
        >.
      </li>
      <li>
        données d'un millésime, d'un référentiel ou d'une nomenclature au format
        geojson (si il posséde un champ géographique) :
        <br />
        l'api renvoient un fichier geojson avec le Content-Type
        <span class="bg-black text-white q-pa-xs">application/json</span>.
      </li>
    </ul>
  </div>
</template>
